import profileRoutes from "@workspace/shared/core/services/profile/profile.routes";
import { api } from "@workspace/shared/core/services/api";
import {
  IInstallations,
  IInstallationsPayload,
  IProfile,
  ISubscription,
} from "@workspace/shared/core/types";

const onGetProfile = () => api.get<IProfile>(profileRoutes.profileRoute);

const onGetSubscriptions = () => api.get<ISubscription[]>(profileRoutes.subscriptionRoute);

const onGetInstallations = () => api.get<IInstallations>(profileRoutes.installationsRoute);

const onCreateInstallation = (payload: IInstallationsPayload) =>
  api.post<IInstallations>(profileRoutes.installationsRoute, payload);

/**
 * Revoke ALL of the user's active sessions (every app, every device) —
 * the dashboard's "close other sessions" takeover, same endpoint the
 * in-game dashboard uses. Only allowed on your own user id.
 */
const onRevokeLogin = (userId: number) => api.delete(profileRoutes.revokeLoginRoute(userId));

/** The apps a coach can ask sales for, by their session name (the dashboard's tiles). */
export type AccessRequestProduct =
  | "ST"
  | "DEF"
  | "QB"
  | "WR"
  | "RB"
  | "TE"
  | "OL"
  | "LB"
  | "DB"
  | "DL"
  | "S"
  | "DC";

/** "Request Access" on a greyed-out dashboard tile (client 2026-11-04): emails sales. */
const onRequestAccess = (product: AccessRequestProduct) =>
  api.post<{ delivered: boolean }>(profileRoutes.requestAccessRoute, { product });

/**
 * "Close Other Sessions" on a locked dashboard tile (client 2026-11-04, as
 * in-game): every other device's seat in the app — teammates' too — is
 * closed so this one can take a seat. Those devices go back to the
 * dashboard; nobody is signed out.
 */
const onCloseOtherSessions = (app: AccessRequestProduct) =>
  api.post<{ closed: number }>(profileRoutes.closeOtherSessionsRoute, { app });

export default {
  onGetProfile,
  onGetSubscriptions,
  onGetInstallations,
  onCreateInstallation,
  onRevokeLogin,
  onRequestAccess,
  onCloseOtherSessions,
};
